import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "catalog-sidebar mb-4" }
const _hoisted_2 = { class: "filters-inner" }
const _hoisted_3 = {
  key: 0,
  class: "filter-category"
}
const _hoisted_4 = {
  key: 0,
  class: "list-categories"
}
const _hoisted_5 = {
  key: 1,
  class: "filter-engine"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Filter by", -1)
const _hoisted_7 = { class: "reset" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FilterMultiChoice = _resolveComponent("FilterMultiChoice")!
  const _component_FilterMinMax = _resolveComponent("FilterMinMax")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mobileOpen)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mobileOpen = false)),
          class: "p-button-sm filter-button mb",
          label: "Hide Filters",
          icon: "pi pi-chevron-down",
          iconPos: "right"
        }))
      : (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mobileOpen = true)),
          class: "p-button-sm filter-button",
          label: "Show Filters",
          icon: "pi pi-chevron-right",
          iconPos: "right"
        })),
    _createElementVNode("div", {
      class: _normalizeClass(['filters', {mobileHidden: !_ctx.mobileOpen}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.subcategories.length > 0)
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.name), 1),
              (_ctx.subcategories)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subcategories, (c) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: c.id
                      }, [
                        _createVNode(_component_router_link, {
                          to: c.url
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(c.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.filters.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (f) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: f.name
                }, [
                  (f.type === 'multi')
                    ? (_openBlock(), _createBlock(_component_FilterMultiChoice, {
                        key: 0,
                        filter: f
                      }, null, 8, ["filter"]))
                    : _createCommentVNode("", true),
                  (f.type === 'minmax')
                    ? (_openBlock(), _createBlock(_component_FilterMinMax, {
                        key: 1,
                        filter: f
                      }, null, 8, ["filter"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.hasFilters)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)), ["prevent"])),
                      href: "#",
                      class: "reset-link"
                    }, [
                      _hoisted_8,
                      _createTextVNode(" Reset Filters ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}